/**
 * Static function to check if a value is empty.
 * The function returns true if the value is:
 * - undefined
 * - null
 * - NaN (for numbers)
 * - an empty string (after trimming)
 * - an empty object (no enumerable properties)
 * - an empty array (no elements)
 *
 * @param value - The value to check
 * @returns boolean - Returns true if the value is considered empty, otherwise false.
 */
export function isEmptyValue(value: unknown): boolean {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'number' && isNaN(value)) ||
    (typeof value === 'string' && value.trim().length === 0) ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (Array.isArray(value) && value.length === 0)
  );
};
